export default {
    setRemovebgLogs: (state, action) => {
        state.data = action.payload;
    },
    setQueryParams: (state, action) => {
        state.queryParams = { ...state.queryParams, ...action.payload };
    },
    clearRemovebgFilters: (state) => {
        state.queryParams = { limit: 100, page: 1, sortDirection: 'DESC', maxDate: null, minDate: null };
    }
}; 